export default object => {
  if (object && Object.values) return Object.values(object);

  // Fallback
  const props = Object.keys(object);
  if (!object || !props) return [];

  return props.map(key => object[key]);
};
